export const managementSearchParams = {
  _clients: {
    clientname: "Client Name",
  },
  _organizations: {
    name: "Organization Name",
  },
  _yachts: {
    name: "Yacht Name",
    urn: "URN",
  },
  _fleet_yachts: {
    name: "Yacht Name",
    urn: "URN",
    account_manager: "Account Manager",
  },
  _roles: {
    user_type: "User type",
    client: "Client Name",
    yacht: "Yacht Name",
    role: "Role name",
    desc: "Description",
  },
  _users: {
    user_name: "User Name",
    yacht: "Yacht Name",
    role: "Role",
    email: "Email",
    ref: "Ref",
  },
};
export const getManagementSearchParams = (
  section: string,
): Record<string, string> => {
  return managementSearchParams[section as keyof typeof managementSearchParams];
};
